module.exports = __webpack_public_path__ + "static/media/AB_K16_4.22e6b566.jpg";